import React from 'react';
import '../styles/RecipeQuiz.css';

const RecipeQuiz = () => {
    return (
        <div className="quiz-container">
            <div className="quiz-header">
                <h1>Recipe Personality Quiz</h1>
                <p className="quiz-subtitle">Discover recipes tailored to your taste and cooking style</p>
            </div>

            <div className="quiz-placeholder">
                <div className="placeholder-icon">🧪</div>
                <h2>Coming Soon!</h2>
                <p>
                    Our recipe personality quiz is currently in development. Soon you'll be able to answer a few quick questions about your cooking preferences, dietary needs, and available time, and we'll recommend the perfect recipes just for you.
                </p>
                
                <div className="quiz-features">
                    <h3>What to expect:</h3>
                    <ul>
                        <li>🎯 Personalized recipe recommendations</li>
                        <li>⏱️ Time-based filtering</li>
                        <li> Dietary preference matching</li>
                        <li>👨‍🍳 Skill level considerations</li>
                        <li>💡 Flavor profile analysis</li>
                    </ul>
                </div>

                <div className="quiz-cta">
                    <p>In the meantime, explore our recipe collection to find your next favorite dish!</p>
                    <a href="/explore" className="explore-link">
                        Browse Recipes
                    </a>
                </div>
            </div>
        </div>
    );
};

export default RecipeQuiz; 